// Models
import { ChangeHandler, RefCallBack } from 'react-hook-form'

// React
import {
  ChangeEvent,
  FC,
  FormEvent,
  InputHTMLAttributes,
  useEffect,
  useState,
} from 'react'

//Custom
import { Container, Input, Label, TextArea } from './styled'

type EventType = FormEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>

type MaskFunction = (value: string) => string

type Props = InputHTMLAttributes<HTMLInputElement> & {
  error?: string
  maskFunction?: MaskFunction
  onBlur: ChangeHandler
  onChange: ChangeHandler
  type?: string
  refName: RefCallBack
  name: string
  value?: string
  disabled?: boolean
}

const InputText: FC<Props> = (props: Props) => {
  const {
    error,
    maskFunction,
    onChange,
    onBlur,
    type,
    refName,
    name,
    value = '',
    placeholder,
    disabled,
  } = props
  const [focused, setFocused] = useState(false)
  const [stateValue, setStateValue] = useState(value)

  const handleOnBlur = (event: EventType) => {
    onBlur(event)
    if (stateValue === '') {
      setFocused(false)
    } else {
      setFocused(true)
    }
  }

  const handleOnChange = (event: EventType) => {
    if (maskFunction) {
      event.currentTarget.value = maskFunction(event.currentTarget.value)
    }
    onChange(event)
    setStateValue(event.currentTarget.value)
  }

  function handleOnFocus() {
    setFocused(true)
  }

  useEffect(() => {
    if (stateValue === '') {
      setFocused(false)
    } else {
      setFocused(true)
    }
  }, [stateValue])

  useEffect(() => {
    setStateValue(value)
  }, [value])

  return (
    <Container>
      {type === 'textarea' ? (
        <TextArea
          data-testid="textarea"
          error={!!error}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          onFocus={handleOnFocus}
          filled={!!stateValue}
          ref={refName}
          name={name}
          disabled={disabled}
        />
      ) : (
        <Input
          data-testid="input"
          error={!!error}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          onFocus={handleOnFocus}
          filled={!!stateValue}
          ref={refName}
          name={name}
          disabled={disabled}
        />
      )}
      <Label
        type={type}
        error={!!error}
        filled={!!stateValue || focused}
        disabled={disabled}>
        {error || placeholder}
      </Label>
    </Container>
  )
}

export default InputText
